export const REFRESH_GROUP_BALANCES_START =
  'REFRESH_GROUP_BALANCES_START';
export const REFRESH_GROUP_BALANCES_SUCCESS =
  'REFRESH_GROUP_BALANCES_SUCCESS';
export const REFRESH_GROUP_BALANCES_FAILED =
  'REFRESH_GROUP_BALANCES_FAILED';
